module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/paste-2d96b8c532cf9d025c124550fa48c132.svg";